const initialState = {
    categories: [],
    subCategories: [],
    pages: [],
}

export default function contentReducer(state = initialState, action) {
    return state
}
